export default __webpack_public_path__ + "static/media/coin.414daf65.svg";